import { render } from "./Button.vue?vue&type=template&id=8f315d14&scoped=true"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=8f315d14&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8f315d14"

export default script